import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "support",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    msgSendStatus: false,
    supportBprmForm: null,
    currentSupportWfTask: null,
    supportAppStartedData: null,
    msgList: [],
    msgReadStatus: false,
    addedNewMessage: { state: false, obj: null },
    supportMsgPopupDocSasUrls: null,
  },
  reducers: {
    supportTicketReceived: (support, action) => {
      support.list = action.payload;
    },
    supportTicketMessageSent: (support, action) => {
      support.msgSendStatus = action.payload;
    },
    supportBprmFormReceived: (support, action) => {
      support.supportBprmForm = action.payload;
    },
    currentSupportWfTaskReceived: (support, action) => {
      support.currentSupportWfTask = action.payload;
    },
    supportAppStartedDataReceived: (support, action) => {
      support.supportAppStartedData = action.payload;
    },
    supportAppMsgListReceived: (messages, action) => {
      messages.msgList = action.payload;
      messages.msgReadStatus = false;
      messages.addedNewMessage = { state: false, obj: null };
    },
    supportAppNewMsgAdded: (messages, action) => {
      const { sasUrls, msg } = action?.payload || {};
      messages.addedNewMessage = { state: true, obj: msg };
      messages.supportMsgPopupDocSasUrls = sasUrls;
    },
    supportAppMsgReadStatusUpdated: (messages, action) => {
      messages.msgReadStatus = action.payload;
    },
  },
});

export const {
  supportTicketReceived,
  supportTicketMessageSent,
  supportBprmFormReceived,
  currentSupportWfTaskReceived,
  supportAppStartedDataReceived,
  supportAppMsgListReceived,
  supportAppNewMsgAdded,
  supportAppMsgReadStatusUpdated,
} = slice.actions;
export default slice.reducer;

export const loadSupportTickets = (id, pageSize, pageNumber) =>
  apiCallBegan({
    url:
      config.GetIssueDefectList +
      id +
      "&pmId=" +
      config.WorkflowIds.SupportPmId +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber,
    onSuccess: supportTicketReceived.type,
  });

export const sendSupportTicketsMessage = (data) =>
  apiCallBegan({
    url: config.SendSupportMessage,
    method: "post",
    data: data,
    onSuccess: supportTicketMessageSent.type,
  });

export const loadSupportBprmForm = (id) =>
  apiCallBegan({
    url: config.GetForm + id,
    onSuccess: supportBprmFormReceived.type,
  });

export const loadSupportCurrentWorkflowTask = (data) =>
  apiCallBegan({
    url: config.GetCurrentWorkflowTask,
    method: "post",
    data: data,
    onSuccess: currentSupportWfTaskReceived.type,
  });

export const startSupportApplication = (data) =>
  apiCallBegan({
    url: config.StartNewApplication,
    method: "post",
    data: data,
    onSuccess: supportAppStartedDataReceived.type,
  });

export const loadSupportAppMsgList = (id) =>
  apiCallBegan({
    url: config.GetMessages + id,
    onSuccess: supportAppMsgListReceived.type,
  });

export const addSupportAppMessage = (data) =>
  apiCallBegan({
    url: config.AddMessage,
    method: "post",
    data: data,
    onSuccess: supportAppNewMsgAdded.type,
  });

export const updateSupportMessageRead = (id, userId) =>
  apiCallBegan({
    url: config.UpdateMessageReadStatus + id + "&perfId=" + userId,
    method: "patch",
    onSuccess: supportAppMsgReadStatusUpdated.type,
  });

export const getSupportTickets = createSelector(
  (state) => state.entities.support,
  (support) => support.list,
);

export const getSupportBprmForm = createSelector(
  (state) => state.entities.support,
  (support) => support.supportBprmForm,
);

export const getCurrentSupportWorkflowTask = createSelector(
  (state) => state.entities.support,
  (support) => support.currentSupportWfTask,
);

export const getStartedSupportAppData = createSelector(
  (state) => state.entities.support,
  (support) => support.supportAppStartedData,
);

export const getSupportAppMsgList = createSelector(
  (state) => state.entities.support,
  (support) => support.msgList,
);

export const getSupportMsgPopupDocSasUrls = createSelector(
  (state) => state.entities.support,
  (support) => support.supportMsgPopupDocSasUrls,
);

export const getSupportAddedNewMsgStatus = createSelector(
  (state) => state.entities.support,
  (support) => support.addedNewMessage,
);

export const getSupportAppMsgReadStatus = createSelector(
  (state) => state.entities.support,
  (support) => support.msgReadStatus,
);
